import { all, call, put, takeLatest, delay } from 'redux-saga/effects';
import { fetchStatusRequest, fetchStatusSuccess, fetchStatusFailure } from '../slices/statusGraphSlice';
import { apiGetCall } from '../api';
import { includeTime, processResponseData, setSessionStorage } from '../../constants/apiUtil';

const max_try = 2;
const retry =500;
 
function* fetchStatusGraphSaga(action: any) {
  const { url, options, version, services } = action.payload;
 
  const isHourly = url.includes("hourly");
  const dataString = isHourly ? `hourly${version}` : `daily${version}`;
  
 for(let attempt =1; attempt<= max_try; attempt++){
    try {
        
        const updatedURL = includeTime(url, isHourly);
        const response = yield call(apiGetCall, updatedURL, options);        
    
        let responseData = yield response.Status;
      
        const sortedData = processResponseData(responseData, isHourly, services);
    
        setSessionStorage(dataString, sortedData, isHourly);
    
        yield put(fetchStatusSuccess(sortedData));
    } catch (error: any) {
        if (attempt< max_try) {
            yield delay (retry)
        } else {
        yield put(fetchStatusFailure(error.message));
        }
    }
 }
}
 
export default function* watchFetchStatusGraphSaga() {
  yield all([takeLatest(fetchStatusRequest.type, fetchStatusGraphSaga)]);
}
 